module.exports = __webpack_public_path__ + "img/antes_despues_275.ffbba4a0.png";